<template>
  <div
    class="commentScroller"
    v-if="latest_comments"
    :style="{ maxHeight: $vuetify.breakpoint.xs ? '260px' : '' }"
  >
    <v-row
      class="px-3 my-n1"
      v-for="comment in latest_comments"
      :key="comment.id"
    >
      <v-hover v-slot="{ hover }">
        <v-col
          :class="hover ? 'grey darken-3' : ''"
          class="latestComment"
          @click="goTo(comment)"
        >
          <v-row v-if="comment.project">
            <v-col cols="2" class="pr-0">
              <v-img
                v-if="comment.project.photo"
                :src="comment.project.photo"
                class="pointer rounded"
                width="30"
                height="30"
              ></v-img>
              <v-img
                v-else
                src="@/assets/LOGO_ALBUM.jpg"
                class="rounded"
                width="30"
                height="30"
              ></v-img>
              <!-- <v-img :src="comment.project.photo" class="pointer" width="30" height="30"></v-img> -->
            </v-col>
            <v-col cols="9" class="text-left grey--text py-1 ml-n2">
              <div class="caption d-inline-block">
                {{ $options.filters.truncate(comment.project.title, 20, " ") }}
              </div>
              -
              <div class="caption d-inline-block">
                {{ $options.filters.truncate(comment.project.year, 25, " ") }}
              </div>
              <div cols="10" class="text-left py-0 grey--text caption mt-n1">
                {{ comment.audit_created_at | parseDateShort }} by
                <strong :class="comment.artist_id ? 'accent--text' : ''">{{
                  $options.filters.truncate(comment.author, 15)
                }}</strong>
              </div>
            </v-col>
            <v-col
              cols="12"
              class="text-left py-0 mt-n1 mt-n2"
              :class="$vuetify.breakpoint.xs ? 'subtitle' : 'body-2'"
            >
              {{ $options.filters.truncate(comment.content, 170, " ") }}
            </v-col>
          </v-row>
          <v-row v-if="comment.news">
            <v-col cols="2" class="pr-0">
              <v-img
                v-if="comment.news.photo"
                :src="comment.news.photo"
                class="pointer rounded"
                width="30"
                height="30"
              ></v-img>
              <v-img
                v-else
                src="@/assets/LOGO_NEWS_50.png"
                class="rounded"
                width="30"
                height="30"
              ></v-img>
            </v-col>
            <v-col cols="9" class=" grey--text text-left py-1 mt-1 ml-n2">
              <div class="caption">
                {{ $options.filters.truncate(comment.news.title, 25, " ") }}
              </div>
              <div cols="10" class="text-left py-0 grey--text caption mt-n1">
                {{ comment.audit_created_at | parseDateShort }} by
                <strong :class="comment.artist_id ? 'accent--text' : ''">{{
                  $options.filters.truncate(comment.author, 15)
                }}</strong>
              </div>
            </v-col>
            <v-col cols="12" class="text-left py-0 mt-n2 body-2">
              {{ $options.filters.truncate(comment.content, 70, " ") }}
            </v-col>
          </v-row>
          <v-row v-if="comment.news_question">
            <v-col cols="2" class="pr-0">
              <v-img
                v-if="comment.news_question.photo"
                :src="comment.news_question.photo"
                class="pointer rounded"
                width="30"
                height="30"
              ></v-img>
              <v-img
                v-else
                src="@/assets/LOGO_NEWS_50.png"
                class="rounded"
                width="30"
                height="30"
              ></v-img>
            </v-col>
            <v-col cols="9" class=" grey--text text-left py-1 mt-1 ml-n2">
              <div class="caption">Front Page Poll</div>
              <div cols="10" class="text-left py-0 grey--text caption mt-n1">
                {{ comment.audit_created_at | parseDateShort }} by
                <strong :class="comment.artist_id ? 'accent--text' : ''">{{
                  $options.filters.truncate(comment.author, 15)
                }}</strong>
              </div>
            </v-col>
            <v-col cols="12" class="text-left py-0 mt-n2 body-2">
              {{ $options.filters.truncate(comment.content, 70, " ") }}
            </v-col>
          </v-row>
          <v-row v-if="comment.topic">
            <v-col cols="2" class="pr-0">
              <v-img
                src="@/assets/LOGO_AVATAR.jpg"
                class="rounded"
                width="30"
                height="30"
              ></v-img>
            </v-col>
            <v-col cols="9" class=" grey--text text-left py-1 mt-1 ml-n2">
              <div class="caption">
                {{ $options.filters.truncate(comment.topic.title, 25, " ") }}
              </div>
              <div cols="10" class="text-left py-0 grey--text caption mt-n1">
                {{ comment.audit_created_at | parseDateShort }} by
                <strong :class="comment.artist_id ? 'accent--text' : ''">{{
                  $options.filters.truncate(comment.author, 15)
                }}</strong>
              </div>
            </v-col>
            <v-col cols="12" class="text-left py-0 mt-n2 body-2">
              {{ $options.filters.truncate(comment.content, 70, " ") }}
            </v-col>
          </v-row>
          <v-row>
            <!-- <v-col cols="4" class="text-left py-0 mt-n1">
								<div class="caption d-inline-block">See more</div>
								<div class="d-inline-block" style="position: relative; top: 2px; left: 4px">→</div> --
							</v-col> -->
          </v-row>
        </v-col>
      </v-hover>
    </v-row>
  </div>
</template>
<script>
import SendRequestMixin from "../../mixins/SendRequestMixin";

export default {
  name: "TheLatestComments",
  mixins: [SendRequestMixin],
  data() {
    return {
      latest_comments: []
    };
  },
  methods: {
    goTo(comment) {
      if (comment.project)
        this.$router.push(
          "/discography/" +
            comment.project.artist_id +
            "/project/" +
            comment.project.id
        );
      else if (comment.news) this.$router.push("/news/" + comment.news.id);
      else if (comment.topic) this.$router.push("/forum/" + comment.topic.id);
    },
    openPopupProject(project) {
      this.$store.commit("mutate", {
        property: "popupProject",
        with: project
      });
    },
    getData() {
      this.sendRequest({
        endpoint: "/latest_comments",
        store_as: "latest_comments",
        list: true
      });
    }
  },
  created() {
    this.getData();
  }
};
</script>
<style lang="sass">
.rounded
	border-radius: 30px

.latestComment
	cursor: pointer
	border-radius: 5px

.commentScroller
	max-height: 30vh
	overflow-x: hidden
	overflow-y: overlay
</style>
